/* ============================================================
   NLO THEME — blog.js
   Blog category tab filtering
   ============================================================ */
'use strict';

document.querySelectorAll('.blog-tabs').forEach(tabBar => {
  tabBar.querySelectorAll('.blog-tab[data-handle]').forEach(tab => {
    tab.addEventListener('click', () => {
      const handle = tab.dataset.handle;
      if (handle) window.location.href = `/blogs/${handle}`;
    });
  });
});

// Mark active tab based on current blog handle
const currentBlogHandle = document.querySelector('[data-current-blog]')?.dataset.currentBlog;
if (currentBlogHandle) {
  document.querySelectorAll(`.blog-tab[data-handle="${currentBlogHandle}"]`).forEach(tab => {
    tab.classList.add('is-active');
  });
}
